import React, { useEffect, useMemo, useState } from "react";

import { TEMPLATES } from '../../../constants';
import { PaymentPromo } from '../paymentPromo';
import { HERO_BANNER_CONTENT } from './constants';

const HeroBannerContent = ({
    altImage,
    firstPackageName,
    fromGradPackages,
    heading,
    hsPaymentPromo,
    hsRepAnnouncement,
    isDegreeSelected,
    packageGroupProducts,
    pageContentDataHeading,
    popularPackage,
    repMessage,
    googleAnalytics
}) => {
    const [templateName, setTemplateName] = useState()

    useEffect(() => {
        window?.template && setTemplateName(window.template)
    }, [])

    const isHighSchoolGraduation = TEMPLATES.HS_GRAD === templateName
    //! Logic for College Graduation Packages was implemented by previous team 
    //! And should be removed after getting clear requirements for this component
    const isCollegeGregPackages = TEMPLATES.COL_GREG_PKG === templateName
    const isPaymentPromoAvailable = hsPaymentPromo && !!packageGroupProducts?.length
    const shouldDisplayDefaultContent = !isDegreeSelected && isCollegeGregPackages
    const hsRepAnnouncementContent = shouldDisplayDefaultContent ? HERO_BANNER_CONTENT.DESCRIPTION : repMessage
    const bannerHeadingContent = heading && isCollegeGregPackages ? heading : pageContentDataHeading
    const bannerHeading = shouldDisplayDefaultContent ? HERO_BANNER_CONTENT.HEADING : bannerHeadingContent

    const paymentPromoProps = useMemo(() => ({
        hsPaymentPromo,
        isBannerMode: true,
        showAfterPay: isHighSchoolGraduation,
        product: fromGradPackages && isCollegeGregPackages ? popularPackage : packageGroupProducts?.[0],
        ...(isCollegeGregPackages && { fromGradPackages, altImage }),
        googleAnalytics
    }), [
        hsPaymentPromo,
        isCollegeGregPackages,
        fromGradPackages,
        popularPackage,
        packageGroupProducts?.[0],
        altImage,
        googleAnalytics
    ])

    const productsTitle = (
        <div className="row mx-0 mx-sm-0 mx-md-0 mx-lg-4">
            <h2 className="text-sm-end">Graduation Products</h2>
        </div>
    )

    const hsGradContent = (
        <div className="overlay group-name">
            <div>
                <ul>
                    <li>
                        <div className='container-fluid ml-3'>
                            <p className="banner-heading">{bannerHeading}</p>
                            {!shouldDisplayDefaultContent && <h1>{firstPackageName}</h1>}
                        </div>
                        {isPaymentPromoAvailable && <PaymentPromo {...paymentPromoProps} />}
                        {(hsRepAnnouncement || shouldDisplayDefaultContent) && (
                            <div className='container-fluid ml-3'>
                                <b>{hsRepAnnouncementContent}</b>
                            </div>
                        )}
                    </li>
                </ul>
            </div>
        </div>
    )

    return isHighSchoolGraduation ? hsGradContent : productsTitle
}

export default HeroBannerContent